import type { ExtraResource, KanjiBonus } from "../types/landing";
export const kanjiBonuses: KanjiBonus[] = [
  {
    number: 1,
    title: "Kanji esenciales",
    description: "Reconocimiento y práctica de caracteres básicos.",
    useCase: "Para dar los primeros pasos con kanji sin mezclarlo todo.",
    kanji: "字",
    meaning: "carácter",
    tone: "pizarra",
  },
  {
    number: 2,
    title: "Kanji en contexto",
    description: "Caracteres trabajados dentro de palabras y ejemplos.",
    useCase: "Para ver cada carácter dentro de una palabra real.",
    kanji: "語",
    meaning: "palabra",
    tone: "terracota",
  },
  {
    number: 3,
    title: "Kanji por temas",
    description: "Organización temática para facilitar el estudio y la consulta.",
    useCase: "Para encontrar rápido los caracteres de un mismo tema.",
    kanji: "類",
    meaning: "categoría",
    tone: "salvia",
  },
  {
    number: 4,
    title: "Práctica de kanji",
    description: "Ejercicios adicionales de escritura y reconocimiento.",
    useCase: "Para sumar repeticiones de escritura y reconocimiento.",
    kanji: "書",
    meaning: "escribir",
    tone: "dorado",
  },
  {
    number: 5,
    title: "Repaso y desafíos",
    description: "Actividades para recuperar conocimientos y revisar dificultades.",
    useCase: "Para volver sobre lo que más te cuesta.",
    kanji: "復",
    meaning: "repasar",
    tone: "sakura",
  },
];
export const extraResources: ExtraResource[] = [
  {
    id: "viajes",
    title: "Japonés práctico para viajes",
    subtitle: "Transporte, alojamiento, comidas, compras y pedidos de ayuda",
    benefit: "Consultás expresiones organizadas según la situación que necesitás resolver.",
    example: "Si estás preparando el check-in del hotel, vas directo a la sección de alojamiento.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/82422e06-e599-4e41-9eab-72ebaa51f4b4.jpg",
  },
  {
    id: "diccionario",
    title: "Diccionario práctico japonés–español · 5.000 palabras",
    subtitle: "Vocabulario de uso frecuente y utilidad cotidiana",
    benefit: "Consultás palabras y ampliás el vocabulario durante el estudio.",
    example: "Si en una lectura aparece una palabra nueva, la buscás en un solo lugar en vez de abrir otra pestaña.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/96610337-32cd-43ff-b3f2-7b5c5c607cb2.jpg",
  },
];
